import { SET_APPROVAL_PAGE_TYPE, SET_APPROVAL_REQUEST_DATA, approvalType, SET_COMMENTS, SET_APPROVAL_TYPE, SET_APPROVAL_STATUS } from "@store/types/approvalTypes";

export interface ApprovalState {
    pageType: any,
    requestData: any,
    comments: string,
    approvalType: any,
    approvalStatus: any
};

const approvalReducer = (
    state = {
        pageType: 'view',
        requestData: {
            requestFor: 'sent',
            requestTrxnId: '',
            requestType: '',
            requestTypeCode: '',
            requestStatus: '',
            requestResubmited: false,
            dataModificationTrackerId: '',
            requestComments: ''
        },
        comments: '',
        approvalType: [],
        approvalStatus: []
    },
    action: approvalType,
): ApprovalState => {
    switch (action.type) {

        case SET_APPROVAL_PAGE_TYPE:
            return { ...state, pageType: action.payload };

        case SET_APPROVAL_REQUEST_DATA:
            return { ...state, requestData: action.payload };

        case SET_COMMENTS:
            return { ...state, comments: action.payload };
            
        case SET_APPROVAL_TYPE:
            return { ...state, approvalType: action.payload };
        case SET_APPROVAL_STATUS:
            return { ...state, approvalStatus: action.payload };

        default:
            return state;
    }
};

export default approvalReducer;
